/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Col_StatusInputs */

const en_directory_agent_readiness_col_status = /** @type {(inputs: Directory_Agent_Readiness_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const zh_directory_agent_readiness_col_status = /** @type {(inputs: Directory_Agent_Readiness_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Directory_Agent_Readiness_Col_StatusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_col_status = /** @type {((inputs?: Directory_Agent_Readiness_Col_StatusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Col_StatusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_col_status(inputs)
	return zh_directory_agent_readiness_col_status(inputs)
});
export { directory_agent_readiness_col_status as "directory.agent_readiness.col.status" }